import GroupCarousel from './GroupCarousel';
import styles from './sonnenhuegel.module.css';
import { useNavigate } from "react-router-dom";
import AG from './AG';
import ags from '../../../../config/ags';
import HeroBanner from '../../../components/HeroBanner/HeroBanner';
import { useState } from 'react';
import ImageModal from '../../../components/ImageModal/ImageModal';
function Sonnenhuegel() {
    const [hasImages, setHasImages] = useState(false);
    const navigate = useNavigate();
    const handleClick = () => {
        window.open("https://lukullus.catering", "_blank");
    };
    const [modalImage, setModalImage] = useState(null);
    return (
        <div className={styles.overallContent}>
            <ImageModal src={modalImage} onClose={() => setModalImage(null)} />
            <HeroBanner category="am-sonnenhuegel" onImagesLoaded={setHasImages} />
            <section className={styles.content} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }} >
                <h1>Grundschule am Sonnenhügel</h1>
                <div>
                    <p>Seit über 25 Jahren gibt es die offene Ganztagsschule (OGS) der Grundschule Sonnenhügel in Oberpleis.
                        Der TuS05 Oberpleis übernahm zum Schuljahr 2006/2007 die Trägerschaft.</p>
                    <table>
                        <tr className={styles.row}>
                            <td className={styles.firstTableItem}>OGS Oberpleis:</td>
                            <td className={styles.secondTableItem}>Insgesamt können wir in unseren Räumlichkeiten eine Betreuung für bis zu 200 Kinder anbieten. Die hell und freundlich ausgestatteten Räume befinden sich in der Grundschule sowie in unserem angrenzenden Vereinsgebäude.
                                In sieben altersgemischten Gruppen (1. – 4. Klasse) haben die Kinder neben der Lernzeitbetreuung die Möglichkeit, spannende Arbeitsgemeinschaften, Bastelangebote und Freispiele zu erleben.</td>
                        </tr>
                        <tr className={styles.row}>
                            <td className={styles.firstTableItem}>OGS Eudenbach:</td>
                            <td className={styles.secondTableItem}>In den Räumen in Eudenbach können bis zu 50 Kinder betreut werden.
                                Auch hier bieten wir neben der Lernzeitbetreuung viele spannende Angebote an.</td>
                        </tr>
                    </table>
                </div>

                <section className={styles.teamContainer}>
                    <h2>Das Team</h2>
                    <div className={styles.team_div}>
                        <div className={styles.team_imgDiv}>
                            <img className={styles.team_img} src={`${process.env.PUBLIC_URL}/images/ogs/das_team.jpg`}
                                onClick={() => {
                                    setModalImage(`${process.env.PUBLIC_URL}/images/ogs/das_team.jpg`);
                                }}
                                alt="Team des OGS's" />
                        </div>
                        <p className={styles.text_p}>Unser Team besteht aus 35 Mitarbeitenden.
                            Die pädagogische Leiterin, Daniela Neußer, und deren Stellvertreterin, Andrea Borutta, werden unterstützt von einer Sozialpädagogin, GruppenleiterInnen, Ergänzungs- und Küchenkräften, PraktikantInnen, Auszubildenden, jungen Erwachsenen im freiwilligen sozialen Jahr und einer Verwaltungsmitarbeiterin.
                            Neben der pädagogischen Arbeit findet ein regelmäßiger Austausch mit der Schulleitung, dem Lehrerkollegium und dem Vorstand sowie der Geschäftsführung des Trägers statt.
                            Regelmäßig durchgeführte Fortbildungen sorgen für eine gute und qualifizierte Ausbildung unserer Mitarbeitenden.</p>
                        <div className={styles.teamAuflistung}>
                            <p>Führungsteam: (v.l.n.r)</p>
                            <table className={styles.table}>
                                <colgroup>
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "70%" }} />
                                </colgroup>
                                <tr>
                                    <td className={styles.firstTableItem}>Cathy Höwer</td>
                                    <td>(Verwaltung)</td>
                                </tr>
                                <tr>
                                    <td className={styles.firstTableItem}>Michael Weber</td>
                                    <td>(Geschäftsführer TuS 05)</td>
                                </tr>
                                <tr>
                                    <td className={styles.firstTableItem}>Andrea Borutta</td>
                                    <td>(stellv. päd. Leitung)</td>
                                </tr>
                                <tr>
                                    <td className={styles.firstTableItem}>Daniela Neußer</td>
                                    <td>(päd. Leitung)</td>
                                </tr>
                                <tr>
                                    <td className={styles.firstTableItem}>Laura Barmsen</td>
                                    <td>(Sozialpädagogin)</td>
                                </tr>
                            </table>
                            <p>fehlend:</p>
                            <table className={styles.table}>
                                <colgroup>
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "70%" }} />
                                </colgroup>
                                <tr>
                                    <td className={styles.firstTableItem}>Vera Pietsch</td>
                                    <td>(Gruppenleitung Eudenbach)</td>
                                </tr>
                            </table>
                        </div>
                        <div className={styles.team_imgDiv}>
                            <img className={styles.team_img} src={`${process.env.PUBLIC_URL}/images/ogs/fuehrungsteam.jpg`}
                                alt="Leitung"
                                onClick={() => {
                                    setModalImage(`${process.env.PUBLIC_URL}/images/ogs/fuehrungsteam.jpg`);
                                }}
                            /></div>
                    </div>
                    <div className={styles.marqueeContainer}>
                        <GroupCarousel setModalImage={setModalImage} />
                    </div>

                </section>

                <section>
                    <h2>Anmeldung / Elternbeiträge</h2>
                    <p>Alles wichtige bzgl. der Anmeldung sowie den Kosten finden Sie hier: <span tabIndex={0} className={styles.link} onClick={() => navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")
                            }
                        }}>Anmeldung / Elternbeiträge</span></p>
                </section>

                <section className={styles.bet}>
                    <h2>Betreuungszeiten</h2>
                    <div className={styles.betreuung}>
                        <div className={styles.betreuung1}>
                            <p><strong>OGS Oberpleis</strong></p>
                            <table className={styles.table}>
                                <colgroup >
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "70%" }} />
                                </colgroup>
                                <tr>
                                    <td >Beginn:</td>
                                    <td>Nach Schulschluss des Kindes</td>
                                </tr>
                                <tr>
                                    <td >Ende:</td>
                                    <td>max. 16:00 Uhr</td>
                                </tr>
                                <tr>
                                    <td >Abholzeiten:</td>
                                    <td>15:00 - 16:00 Uhr</td>
                                </tr>
                            </table>
                        </div>
                        <div className={styles.betreuung2}>
                            <p><strong>OGS Eudenbach</strong></p>
                            <table className={styles.table}>
                                <colgroup>
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "70%" }} />
                                </colgroup>
                                <tr>
                                    <td>Beginn:</td>
                                    <td>Nach Schulschluss des Kindes</td>
                                </tr>
                                <tr>
                                    <td>Ende:</td>
                                    <td>max. 16:15 Uhr</td>
                                </tr>
                                <tr>
                                    <td>Abholzeiten:</td>
                                    <td>15:00 - 15:15 Uhr und</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>16:15 - 16:30 Uhr</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <p><strong>Zusätzliche Betreuungszeiten</strong></p>
                    <ul className={styles.list}>
                        <li>Notbetreuung von 7:30 - 13:10 Uhr an Konzeptions- oder Fortbildungstagen der Schule sowie an beweglichen Ferientagen</li>
                        <li>Kostenpflichtige ganztägige Ferienbetreuung von 7:30 - 16:00 Uhr am Standort Oberpleis
                            <ul className={styles.list}>
                                <li>1. Herbstferienwoche, 1. Osterferienwoche, 1. und 2. Sommerferienwoche</li>
                                <li>Die Ferienbetreuung wird jedes Jahr vom OGS-Team zu einem bestimmten Thema gestaltet.</li>
                                <li>Hier erlernen die Kinder in verschiedenen pädagogischen Workshops, als auch bei Ausflügen unterschiedliche Fähigkeiten und Fertigkeiten.</li>
                            </ul>
                        </li>
                    </ul>
                    <p><strong>Wichtige Informationen:</strong></p>
                    <ul className={styles.list}>
                        <li>Die Abholzeiten sind für alle fünf Wochentage festzulegen</li>
                        <li>Die verbindlichen Festlegungen der Abholzeiten erfolgt jeweils zu Beginn jedes Schuljahres</li>
                        <li>Aus pädagogischen und organisatorischen Gesichtspunkten ist die Einhaltung der Abholzeiten wichtig.</li>
                        <li>Abweichungen und Änderungen im laufenden Schulhalbjahr sind nur im begründeten Einzelfall mit Zustimmung der OGS-Leitung möglich.</li>
                        <li>Die Kinder werden eigenverantwortlich, nach Abmeldung in der jeweiligen Gruppe, entlassen.</li>
                        <li>Es liegt nicht in der Verantwortung der Mitarbeitenden, die Kinder an abholberechtigte Personen zu übergeben.</li>
                        <li>Während der Abholzeiten am Nachmittag 15:00 / 16:00 Uhr ist ein Mitarbeiter/eine Mitarbeiterin als Aufsichtsperson mit im Forum.</li>
                    </ul>
                </section>
                <section>
                    <h2>Mittagessen</h2>
                    <div className={styles.mittagessenContainer}>
                        <img
                            tabIndex={0}
                            src={`${process.env.PUBLIC_URL}/images/ogs/lukullus-logo-kurz.svg`}
                            alt="Lukulls Catering Logo"
                            onClick={handleClick}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    handleClick()
                                }
                            }}
                            style={{ cursor: "pointer" }} />
                        <p>Die Kinder erhalten bei uns ein gesundes, ausgewogenes und kindgerechtes Mittagessen.<br /> Das Essen wir von unserem Partner Lukullus Catering täglich frisch zubereitet und geliefert.</p>
                    </div>
                </section>

                <section className={styles.arbeitsgemeinschaften}>
                    <h2>Arbeitsgemeinschaften</h2>
                    <p>AG`s sind neu gestaltete Einheiten, die entspannen, Spaß machen, lern- und informationsreich sind, das Kind herausfordern und fördern.<br />Im Nachmittagsbereich finden in der OGS zahlreiche und vielfältige AG‘s statt, die zu Beginn des Schuljahres und Halbjahres von den Kindern und ihren Eltern gewählt werden können. Die Auswahl ist sehr breit gefächert und besteht aus sportlichen, musikalischen und kreativen Aktivitäten, sodass jedes Kind garantiert ein für sich passendes Angebot findet.<br />Es werden keine zusätzlichen Beiträge für die regelmäßige Teilnahme erhoben. Soweit solche Kosten entstehen, werden diese vom OGS-Träger aus den monatlichen Elternbeiträgen bestritten.</p>
                    <div className={styles.ags}>
                        {ags.map((item, index) => (
                            AG(item)
                        ))}
                    </div>
                </section>

            </section>
        </div>
    )
}

export default Sonnenhuegel;